import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import capitalize from "../../../../../../capitalize";

const categories = ["Nylon", "PET Plastic"];

const EvacModal1 = ({
  driverName,
  setDriverName,
  driverPhone,
  setDriverPhone,
  plateNo,
  setPlateNo,
  nylon,
  setNylon,
  pet,
  setPet,
  showEvac1,
  handleCloseEvac1,
  captureEvacuation,
  selectedCategories,
  setSelectedCategories,
  loading,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // one ref that wraps BOTH the input and the dropdown
  const categoryContainerRef = useRef(null);

  const handleCheckboxChange = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };

  const handleInputClick = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const placeholderText = selectedCategories.length
    ? selectedCategories.join(", ")
    : "Select plastic categories";

  // Reliable outside click handler
  useEffect(() => {
    const onDocMouseDown = (e) => {
      if (
        categoryContainerRef.current &&
        !categoryContainerRef.current.contains(e.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", onDocMouseDown);
    return () => document.removeEventListener("mousedown", onDocMouseDown);
  }, []);

  //   console.log(selectedCategories)
  return (
    <div>
      <Modal
        show={showEvac1}
        onHide={() => {
          // Close = pause. The local draft is kept so the user can resume
          // this step from the "Resume" card.
          handleCloseEvac1();
        }}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="px-2">
            {/* Row 1 */}
            <div>
              <p
                style={{
                  fontWeight: "600",
                  color: "#000",
                  fontSize: "18px",
                  marginBottom: "4px",
                }}
              >
                Initiate Evacuation Request
              </p>
              <p style={{ fontSize: "12px", color: "#898989" }}>Step 1 of 2</p>
            </div>
            <Row>
              <Col xs={12} md={6} className="text-left">
                <Form.Label htmlFor="driverName">Driver&apos;s Name</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    id="driverName"
                    className="py-4"
                    value={driverName}
                    onChange={(e) => setDriverName(e.target.value.replace(/[^a-zA-Z]/g, ""))}
                  />
                </div>
              </Col>

              <Col xs={12} md={6} className="text-left">
                <Form.Label htmlFor="driverPhone">
                  Driver&apos;s Phone Number
                </Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    id="driverPhone"
                    className="py-4"
                    maxLength={11}
                    value={driverPhone}
                    onChange={(e) =>
                      setDriverPhone(e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                </div>
              </Col>
            </Row>

            {/* Row 2 */}
            <div className="py-3">
              <Row>
                <Col xs={12} md={6} className="text-left">
                  <Form.Label htmlFor="plateNo">
                    Vehicle&apos;s Plate No
                  </Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      type="text"
                      id="plateNo"
                      className="py-4"
                      value={plateNo}
                      onChange={(e) => setPlateNo(e.target.value)}
                    />
                  </div>
                </Col>

                {/* <Col xs={12} md={6} className="text-left">
                  <Form.Label>Select Plastic Categories</Form.Label>

                  <div
                    ref={categoryContainerRef}
                    className="category-selectors"
                  >
                    <Form.Control
                      type="text"
                      className="form-control form-control-lg inputStyle py-4"
                      placeholder={placeholderText}
                      readOnly
                      onClick={handleInputClick}
                      onMouseDown={(e) => e.stopPropagation()}
                    />

                    {isDropdownOpen && (
                      <div className="dropdown mt-2">
                        {categories.map((category, index) => (
                          <div key={category} className="dropdown-item">
                            <label className="d-flex">
                              <input
                                type="checkbox"
                                id={`checkbox-${index}`}
                                checked={selectedCategories.includes(category)}
                                onChange={() => handleCheckboxChange(category)}
                              />
                              <span className="mb-0 pl-2">{category}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </Col> */}
              </Row>
            </div>

            {/* Row 3 – category-specific fields */}
            {/* <div className="pb-3">
              <Row>
                {selectedCategories.includes("Nylon") && (
                  <Col xs={12} md={6} className="text-left">
                    <Form.Label htmlFor="nylon">Nylon (kg)</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        id="nylon"
                        className="py-4"
                        value={nylon}
                        onChange={(e) =>
                          setNylon(e.target.value.replace(/[^0-9.]/g, ""))
                        }
                      />
                    </div>
                  </Col>
                )}

                {selectedCategories.includes("PET Plastic") && (
                  <Col xs={12} md={6} className="text-left">
                    <Form.Label htmlFor="pet">PET Plastic (kg)</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        id="pet"
                        className="py-4"
                        value={pet}
                        onChange={(e) =>
                          setPet(e.target.value.replace(/[^0-9.]/g, ""))
                        }
                      />
                    </div>
                  </Col>
                )}
              </Row>
            </div> */}
            <div style={{ width: "40%" }} className="pt-1 pb-3">
              <button
                style={{ fontSize: "13px" }}
                type="button"
                className="btn loginBtn btn-sm btn-block"
                onClick={() => {
                  // handleShowEvac1();
                  captureEvacuation();
                }}
              >
                {loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Continue to Capture"
                )}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EvacModal1;
